import SelectPopover from 'src/components/SelectPopover/SelectPopover.component';
import CheckBoxPopover from 'src/pages/monitoring/checkbox/CheckBoxPopover.component';
import {
  ChangeEvent,
  Dispatch,
  MouseEventHandler,
  SetStateAction,
} from 'react';
import { Buyers } from 'src/services/linksFilterInitialData/linksFilterInitialData.types';
import { DataFormPayByLink } from '../../SearchCriteriaForm.helpers';
import { clientList } from '../../SearchCriteriaForm.config';

type BuyersPopoverProps = {
  buyersList?: Buyers[];
  submitHandler?: MouseEventHandler | undefined;
  setData: Dispatch<SetStateAction<Buyers[] | undefined>>;
  initialData?: Buyers[];
  dataFiltered: DataFormPayByLink;
  onCloseHandler?: () => void;
};
export const BuyersPopover: React.FC<BuyersPopoverProps> = ({
  buyersList,
  submitHandler,
  setData,
  initialData,
  dataFiltered,
  onCloseHandler,
}) => {
  const onChangeBuyersHandler = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const newList = buyersList?.filter(({ Name }) =>
      Name.toLowerCase().includes(value.toLowerCase()),
    );
    setData(value?.length > 0 ? newList : initialData);
  };
  const count =
    dataFiltered.buyers.length > 0 ? dataFiltered.buyers.length : undefined;
  return (
    <SelectPopover
      onChangeHandler={onChangeBuyersHandler}
      submitHandler={submitHandler}
      label="lbl.customers"
      countFilters={count}
      onCloseHandler={onCloseHandler}
    >
      {buyersList?.map(({ Name, Id }) => (
        <CheckBoxPopover
          key={Id}
          fieldName={clientList}
          label={Name}
          id={Id.toString()}
        />
      ))}
    </SelectPopover>
  );
};

export default BuyersPopover;
